import { createAsyncThunk } from "@reduxjs/toolkit";
import config from "../../config";
import axiosClient from "../../common/api/request";

// Reviews of one item — public, guests included. Own review comes pinned
// first with is_mine: true.
export const getItemReviews = createAsyncThunk(
  "reviews/get_item_reviews",
  async ({ menuItemId, ...params }, { rejectWithValue }) => {
    try {
      const data = await axiosClient.get(
        `${config.API_URL_V2}/menu_items/${menuItemId}/reviews/`,
        {
          params, // { page, per_page }
        }
      );
      return data;
    } catch (error) {
      if (
        error?.response &&
        error?.response?.data &&
        typeof error?.response?.data === "object"
      ) {
        return rejectWithValue(error?.response?.data);
      } else {
        return rejectWithValue(error?.message);
      }
    }
  }
);

// The logged-in customer's review history (rows are reviews, each with a
// compact menu_item card). Guests get 403.
export const getMyReviews = createAsyncThunk(
  "reviews/get",
  async (params, { rejectWithValue }) => {
    try {
      const data = await axiosClient.get(`${config.API_URL_V2}/reviews/`, {
        params, // { page, per_page, search, has_comment, min_rating }
      });
      return data;
    } catch (error) {
      if (
        error?.response &&
        error?.response?.data &&
        typeof error?.response?.data === "object"
      ) {
        return rejectWithValue(error?.response?.data);
      } else {
        return rejectWithValue(error?.message);
      }
    }
  }
);

// Upsert — create and edit are the same call; re-posting overwrites the
// customer's existing review of that item.
export const submitReview = createAsyncThunk(
  "reviews/submit_item",
  async ({ menuItemId, rating, comment }, { rejectWithValue }) => {
    try {
      const data = await axiosClient.post(
        `${config.API_URL_V2}/reviews/items/`,
        {
          menu_item_id: menuItemId,
          rating,
          ...(comment !== undefined ? { comment } : null),
        }
      );
      return data;
    } catch (error) {
      if (
        error?.response &&
        error?.response?.data &&
        typeof error?.response?.data === "object"
      ) {
        return rejectWithValue(error?.response?.data);
      } else {
        return rejectWithValue(error?.message);
      }
    }
  }
);

// Keyed by the ITEM id (one review per customer per item), idempotent.
export const removeReview = createAsyncThunk(
  "reviews/remove_item",
  async (menuItemId, { rejectWithValue }) => {
    try {
      const data = await axiosClient.delete(
        `${config.API_URL_V2}/reviews/items/${menuItemId}/`
      );
      return data;
    } catch (error) {
      if (
        error?.response &&
        error?.response?.data &&
        typeof error?.response?.data === "object"
      ) {
        return rejectWithValue(error?.response?.data);
      } else {
        return rejectWithValue(error?.message);
      }
    }
  }
);
